import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import PerfectScrollbar from "react-perfect-scrollbar";
import Footer from "../shared/Footer";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const OrderSettingsForm = () => {
  const [settings, setSettings] = useState({
    max_price: "",
    neutral_color: "",
    secondary_color: "",
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def) => translations[key] || def;

  useEffect(() => {
    fetchData();
  }, []);

  const formatNumber = (value) => {
    if (!value) return "";
    return new Intl.NumberFormat("tr-TR").format(value);
  };

  const fetchData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/order-settings/1`);
      const data = res.data || {};

      setSettings((prev) => ({
        ...prev,
        ...data,
      }));

      // 🔥 renk direkt uygula
      if (data.neutral_color) {
        document.documentElement.style.setProperty(
          "--neutral",
          data.neutral_color,
        );
      }
      if (data.secondary_color) {
        document.documentElement.style.setProperty(
          "--secondary",
          data.secondary_color,
        );
      }
    } catch (err) {
      console.error("Order settings alınamadı:", err);
      toast.error("Order ayarları alınamadı!");
    }
  };

  const handlePriceChange = (e) => {
    let value = e.target.value;

    // sadece rakamları al
    value = value.replace(/\D/g, "");

    // baştaki sıfırları engelle
    if (value.startsWith("0")) {
      value = value.replace(/^0+/, "");
    }

    setSettings((prev) => ({
      ...prev,
      max_price: value,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      await axios.put(`${BASE_URL}/api/order-settings/1`, settings);

      // 🔥 anında uygula
      if (settings.neutral_color) {
        document.documentElement.style.setProperty(
          "--neutral",
          settings.neutral_color,
        );
      }
      if (settings.secondary_color) {
        document.documentElement.style.setProperty(
          "--secondary",
          settings.secondary_color,
        );
      }

      toast.success(getText("SUCCESS_API_UPDATED"));
      fetchData();
    } catch (err) {
      console.error("Kaydedilemedi:", err);
      toast.error("Kayıt hatası!");
    }
  };
  return (
    <div className="content-area setting-form">
      <ToastContainer />

      <div className="content-area-body">
        <div className="card mb-0">
          <div className="card-body">
            {/* 🔥 MAX PRICE */}
            <div className="mb-3">
              <label className="form-label fw-bold">
                {getText("ORDER_MAX_PRICE")}
              </label>
              <input
                type="text"
                className="form-control"
                value={formatNumber(settings.max_price)}
                onChange={handlePriceChange}
                placeholder="ex: 10.000"
              />
            </div>
            {/* 🎨 TEMA RENGİ */}
            <div className="mb-3">
              <label className="form-label fw-bold">
                {getText("ORDER_THEME_COLOR")}
              </label>

              <div className="d-flex gap-12 align-items-center">
                <input
                  type="color"
                  name="neutral_color"
                  value={settings.neutral_color || "#f3f4f6"}
                  onChange={handleChange}
                  style={{ width: 60, height: 40, border: "none" }}
                />

                <input
                  type="text"
                  name="neutral_color"
                  className="form-control"
                  value={settings.neutral_color || ""}
                  onChange={handleChange}
                  placeholder="#f3f4f6"
                />
              </div>
            </div>
            {/* 🎨 SECONDARY COLOR */}
            <div className="mb-3">
              <label className="form-label fw-bold">
                {getText("SECONDARY_COLOR")}
              </label>

              <div className="d-flex gap-12 align-items-center">
                <input
                  type="color"
                  name="secondary_color"
                  value={settings.secondary_color || "#B68150"}
                  onChange={handleChange}
                  style={{ width: 60, height: 40, border: "none" }}
                />

                <input
                  type="text"
                  name="secondary_color"
                  className="form-control"
                  value={settings.secondary_color || ""}
                  onChange={handleChange}
                  placeholder="#B68150"
                />
              </div>
            </div>

            {/* SAVE */}
            <div className="d-flex justify-content-center">
              <button className="btn btn-primary" onClick={handleSave}>
                <FiSave className="me-2" />
                {getText("SAVE_BTN")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSettingsForm;
